export default __webpack_public_path__ + "static/media/motherThree.4711288b.jpeg";